<template>
  <div id="nav-right-with-contact-v-extended-toolbar">
    <div id="header" class="nav-right-with-contact" :data-site-brand="currentBrand"
      :data-theme="currentBrand" :data-has-color-fill="'false'" :data-dark-color-is-primary="'false'"
      :data-has-hours-display="'true'" :data-oem-website-brand="''" :data-apply-dealer-name-css="'false'"
      :data-directions="'/directions'">
      <div class="hidden-sm hidden-xs">
        <div class="nav-height"></div>
        <nav class="navbar navbar-inverse navbar-fixed-top" role="navigation">
          <header id="desktop-header" :data-collapsible="'false'">
            <div class="container max-w-adjust">
              <div class="header-wrapper clearfix">
                <div id="desktop-logo">
                  <a href="#" :style="{ backgroundImage: `url(${logoURL ? logoURL : logoSRC})` }"></a>
                </div>
                <a class="skip-navigation" href="#">SKIP NAVIGATION</a>
                <div class="nav-toolbar-side">
                  <div class="nav-contact-toolbar" :data-items="'phone-sales phone-service address hours translate'"
                    :data-has-multiple-phones="'true'" :data-has-matching-phones="'true'"
                    :data-extended-version="'true'" :data-hours-dropdown="'false'" :data-phone-dropdown="'false'"
                    :data-matching-phones-dropdown-check="'false'" :data-social-dropdown="'false'"
                    :data-address-enabled="'true'" :data-translate-enabled="'true'">
                    <div class="row row-no-gutters">
                      <div class="col-xs-12">
                        <div class="vcenter toolbar-phone-numbers">
                          <div class="text-center">
                            <a href="#" aria-label="sales number" class="sales phone-link phone-sales ws-dynamic-number"
                              data-number-type="sales">
                              <span>Sales & service:&nbsp;</span>
                              <span>(919) 123-4567</span>
                            </a>
                          </div>
                        </div>
                        <div class="vcenter hidden-md toolbar-address">
                          <div class="address">
                            <a alt="11550 Common Oaks Drive #204, Raleigh, NC 27614" aria-label="address"
                              class="track-click" data-action="Address Click" data-category="Hours &amp;amp; Directions"
                              data-label="Dealership Address Link" href="#">11550 Common Oaks Drive #204,
                              Raleigh, NC 27614</a>
                          </div>
                        </div>
                        <div class="vcenter toolbar-hours">
                          <a aria-label="hours" class="event-click track-click hours-link" data-action="Hours Click"
                            data-category="Hours &amp;amp; Directions" data-label="Dealership Hours Link" href="#"><i
                              aria-hidden="true" class="fa fa-clock-o"></i><span>&nbsp;&nbsp;<span
                                class="nav-hour nav-hour--sales"><span class="category-delimiter"></span><span
                                  class="category-name">Sales: </span><span class="hour hour-open">9</span><span
                                  class="field-delimiter"> - </span><span class="hour hour-close">7</span></span><span
                                class="nav-hour nav-hour--service"><span class="category-delimiter"> • </span><span
                                  class="category-name">Service: </span><span class="hour hour-open">7:30</span><span
                                  class="field-delimiter"> - </span><span class="hour hour-close">5</span></span></span>
                          </a>
                        </div>
                        <div class="vcenter toolbar-select-language">
                          <a aria-label="Select Language" class="event-click track-click translate-link"
                            data-action="Select Language" data-category="Nav Utility Bar" href="#"><i aria-hidden="true"
                              class="fa fa-globe"></i><span>&nbsp;&nbsp;Select Language&nbsp;</span><i
                              aria-hidden="true" class="fa fa-caret-down"></i>
                          </a>
                        </div>
                        <div class="vcenter toolbar-socials">
                          <div class="social-media-icons">
                            <a class="social-media-link track-click" href="#"
                              data-category="Social Media" data-action="click" data-label="Facebook"
                              aria-label="Facebook"><span class="visuallyhidden">opens in a new window</span><i
                                class="fa fa-facebook" aria-hidden="true"></i></a>
                            <a class="social-media-link track-click" href="#"
                              data-category="Social Media" data-action="click" data-label="Instagram"
                              aria-label="Instagram"><span class="visuallyhidden">opens in a new window</span><i
                                class="fa fa-instagram" aria-hidden="true"></i></a>
                            <a class="social-media-link track-click" href="#"
                              data-category="Social Media" data-action="click" data-label="YouTube"
                              aria-label="YouTube"><span class="visuallyhidden">opens in a new window</span><i
                                class="fa fa-youtube" aria-hidden="true"></i></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ul class="navbar-nav" data-more-dropdown="false" id="desktop-menu" role="menubar">
                  <li class="dropdown models-dropdown collapse" role="none" @mouseenter="addOpen"
                    @mouseleave="removeOpen">
                    <a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown"
                      data-model-dropdown="true" data-section-title="Shop" data-toggle="dropdown" href="#"
                      role="menuitem" target="">{{ menuSections.length ? menuSections[0].label : 'New' }}</a>
                    <ul aria-label="Shop" class="dropdown-menu models-dropdown-menu" role="menu" aria-expanded="false">
                      <div class="vehicle-model-dropdown" data-section-title="Shop">
                        <div class="dropdown-container">
                          <div class="dropdown-wrapper">
                            <div class="model-column">
                              <div class="models-wrapper">
                                <div class="model-container" v-for="suv in images.suvs" :key="suv.modelName"><a href="#">
                                    <div class="model-text">
                                      <h3 role="presentation">{{ suv.modelName }}</h3><span class="vehicles-count">10
                                        available</span>
                                    </div>
                                    <img
                                      :alt="suv.modelName"
                                      :src="suv.angleView"
                                    />
                                  </a>
                                </div>
                                <div class="model-container" v-for="truck in images.trucks" :key="truck.modelName"><a href="#">
                                    <div class="model-text">
                                      <h3 role="presentation">{{ truck.modelName }}</h3><span class="vehicles-count">45
                                        available</span>
                                    </div>
                                    <img
                                      :alt="truck.modelName"
                                      :src="truck.angleView"
                                    />
                                  </a>
                                </div>
                                <div class="model-container" v-for="sedan in images.sedans" :key="sedan.modelName"><a href="#">
                                    <div class="model-text">
                                      <h3 role="presentation">{{ sedan.modelName }}</h3><span class="vehicles-count">32
                                        available</span>
                                    </div>
                                    <img
                                      :alt="sedan.modelName"
                                      :src="sedan.angleView"
                                    />
                                  </a>
                                </div>
                                <!-- <div class="model-container" v-for="ev in images.evs" :key="ev.modelName"><a href="#">
                                    <div class="model-text">
                                      <h3 role="presentation">{{ ev.modelName }}</h3><span class="vehicles-count">24
                                        available</span>
                                    </div>
                                    <img
                                      :alt="ev.modelName"
                                      :src="ev.angleView"
                                    />
                                  </a>
                                </div> -->
                              </div>
                            </div>
                            <div class="search-column">
                              <div class="search-btns">
                                <li
                                  v-for="(item, itemIndex) in menuSections[0].items"
                                  :key="itemIndex"
                                  role="none"
                                >
                                  <a class="btn" href="#" role="menuitem">{{ item.title }}</a>
                                </li>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </li>
                  <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen"><a
                      aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown"
                      data-model-dropdown="" data-section-title="Discover" data-toggle="dropdown" href="#"
                      role="menuitem" target="">{{ menuSections.length ? menuSections[1].label : 'Pre-Owned' }}</a>
                    <ul aria-label="Discover" class="dropdown-menu" role="menu">
                      <li
                        v-for="(item, itemIndex) in menuSections[1].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen"><a
                      aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown"
                      data-model-dropdown="" data-section-title="Service &amp; Parts" data-toggle="dropdown" href="#"
                      role="menuitem" target="">{{ menuSections.length ? menuSections[2].label : 'Service & Parts' }}</a>
                    <ul aria-label="Service &amp; Parts" class="dropdown-menu" role="menu">
                      <li
                        v-for="(item, itemIndex) in menuSections[2].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen"><a
                      aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown"
                      data-model-dropdown="" data-section-title="Financing" data-toggle="dropdown" href="#"
                      role="menuitem" target="">{{ menuSections.length ? menuSections[3].label : 'Financing' }}</a>
                    <ul aria-label="Financing" class="dropdown-menu" role="menu">
                      <li
                        v-for="(item, itemIndex) in menuSections[3].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen"><a
                      aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown"
                      data-model-dropdown="" data-section-title="Ownership" data-toggle="dropdown" href="#"
                      role="menuitem" target="">{{ menuSections.length ? menuSections[4].label : 'Research' }}</a>
                    <ul aria-label="Ownership" class="dropdown-menu" role="menu">
                      <li
                        v-for="(item, itemIndex) in menuSections[4].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown" role="none" @mouseenter="addOpen" @mouseleave="removeOpen"><a
                      aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown"
                      data-model-dropdown="" data-section-title="About" data-toggle="dropdown" href="#" role="menuitem"
                      target="">{{ menuSections.length ? menuSections[5].label : 'About' }}</a>
                    <ul aria-label="About" class="dropdown-menu" role="menu">
                      <li
                        v-for="(item, itemIndex) in menuSections[5].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                    </ul>
                  </li>
                  <li><a aria-label="search" href="#dropdown-search"></a>
                    <div class="hidden" id="dropdown-search">
                      <div class="container">
                        <div class="search-bar">
                          <form action="/vehicles" role="search">
                            <div class="input-group">
                              <input aria-label="Search Bar" autocomplete="off" autocorrect="off"
                                class="form-control input-search" data-custom="false" data-placement="bottom"
                                data-search-suggestions="true" data-suggest="true" data-top="Browse new inventory"
                                name="query" placeholder="Order Parts" spellcheck="false" title="Search this site..."
                                type="text" value="">
                              <span class="input-group-btn">
                                <button aria-label="search text"
                                  class="btn btn-default no-border-left search-submit-btn" type="submit"><i
                                    aria-hidden="true" class="fa fa-search"></i><span
                                    class="alternate-btn-text hidden">Search</span>
                                </button>
                                <span aria-label="pause automatic search suggest" aria-pressed="false"
                                  class="btn btn-default toggleSearchText visuallyhidden" role="button" tabindex="0"><i
                                    aria-hidden="true" class="fa fa-pause"></i></span></span>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </header>
        </nav>
      </div>
      <div class="visible-sm visible-xs">
        <div class="nav-height"></div>
        <div class="click-through-mobile-contact-bar navbar navbar-fixed-top" data-has-utility-bar-content="true"
          data-include-margins="true" data-mobile-hours-should-display="true" :class="{ 'offcanvas-menu': sideNavOpen }"
          style="top: 0px;">
          <a class="toggle-side-click-through-menu js-menu-toggle" href="#" @click.prevent="toggleSideNav">
            <div class="mobile-menu-toggle">
              <span class="icon-label">MENU</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </div>
          </a>
          <div class="mobile-dealer-logo">
            <a class="dealer-logo" href="#" :style="{ backgroundImage: `url(${logoURL ? logoURL : logoSRC})` }"></a>
          </div>
          <div class="contact-info">
            <div class="contact-item mobile-sales-phone" data-has-call-text="false" id="toggle-click-to-call">
              <i class="fa fa-phone"></i>
            </div>
            <a class="contact-item mobile-get-directions" data-action="Address Click" data-category="Hours & Directions"
              data-label="Dealership Address Link" href="#">
              <i aria-hidden="true" class="fa fa-map-marker"></i>
              <span class="visuallyhidden">Get Directions</span>
            </a>
          </div>
          <div class="mobile-nav-utility-bar" data-items-count="2" data-show-multiple-hours="true"
            data-nav-hour-index="0">
            <div class="vcenter toolbar-hours">
              <a aria-label="hours" class="event-click track-click hours-link" data-action="Hours Click"
                data-category="Hours & Directions" data-label="Dealership Hours Link" href="#">
                <i aria-hidden="true" class="fa fa-clock-o"></i>
                <span>&nbsp;&nbsp;
                  <span class="nav-hour nav-hour--sales active" data-index="0">
                    <span class="category-delimiter"></span>
                    <span class="category-name">Sales: </span>
                    <span class="hour hour-open">9</span>
                    <span class="field-delimiter"> - </span>
                    <span class="hour hour-close">7</span>
                  </span>
                  <span class="nav-hour nav-hour--service" data-index="1">
                    <span class="category-delimiter"> • </span>
                    <span class="category-name">Service: </span>
                    <span class="hour hour-open">7:30</span>
                    <span class="field-delimiter"> - </span>
                    <span class="hour hour-close">5</span>
                  </span>
                </span>
              </a>
            </div>
            <div class="vcenter toolbar-select-language">
              <a aria-label="Select Language" class="event-click track-click translate-link"
                data-action="Select Language" data-category="Nav Utility Bar" href="#">
                <i aria-hidden="true" class="fa fa-globe"></i>
                <span>&nbsp;&nbsp;Select Language&nbsp;</span>
                <i aria-hidden="true" class="fa fa-caret-down"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="visible-sm visible-xs">
        <div class="click-through-mobile-nav-bar" id="click-through-sidr" role="navigation">
          <div class="navbar-outer">
            <div class="navbar-header-items">
              <div class="navbar-directions"><a class="close-dropdown-view hide" href="#" @click.prevent="closeSideDropdown"><img alt="Go Back"
                    src="https://d2v1gjawtegg5z.cloudfront.net/assets/left-arrow-white-cf25d7bbda1574930ab482b17046d87f0e6dda28bf6f95772b8325219ec3e49d.png"></a><a
                  class="toggle-side-click-through-menu js-menu-toggle close-mobile-wrap" href="#" @click.prevent="closeSideNav"><span
                    class="close-mobile-nav"><span>×</span></span></a></div>
              <div class="search-bar">
                <form action="/vehicles" role="search">
                  <div class="input-group"><input aria-label="Search Bar" autocomplete="off" autocorrect="off"
                      class="form-control input-search" data-custom="false" data-placement="bottom"
                      data-search-suggestions="true" data-suggest="true" data-top="2025 SUV's" name="query"
                      placeholder="New 2025 SUV's" spellcheck="false" title="Search this site..." type="text"
                      value=""><span class="input-group-btn"><button aria-label="search text"
                        class="btn btn-default no-border-left search-submit-btn" type="submit"><i aria-hidden="true"
                          class="fa fa-search"></i><span class="alternate-btn-text hidden">Search</span></button><span
                        aria-label="pause automatic search suggest" aria-pressed="false"
                        class="btn btn-default toggleSearchText visuallyhidden" role="button" tabindex="0"><i
                          aria-hidden="true" class="fa fa-pause"></i></span></span></div>
                </form>
              </div>
            </div>
            <div class="navbar-inner nav navbar-nav">
              <ul class="side-nav" role="menu">
                <li class="dropdown" role="none" @click="openSideDropdown"><a
                    aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-hover="dropdown"
                    data-model-dropdown="true" data-section-title="Shop" data-toggle="dropdown" href="#"
                    role="menuitem" target="">{{ menuSections.length ? menuSections[0].label : 'New' }}</a>
                  <ul aria-label="Shop" class="dropdown-menu" role="menu">
                    <li
                        v-for="(item, itemIndex) in menuSections[0].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @click.prevent="openSideDropdown"><a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle"
                    data-hover="dropdown" data-model-dropdown="" data-section-title="Discover" data-toggle="dropdown"
                    href="#" role="menuitem" target="">{{ menuSections.length ? menuSections[1].label : 'Pre-Owned' }}</a>
                  <ul aria-label="Discover" class="dropdown-menu" role="menu">
                    <li
                        v-for="(item, itemIndex) in menuSections[1].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @click="openSideDropdown"><a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle"
                    data-hover="dropdown" data-model-dropdown="" data-section-title="Service &amp; Parts"
                    data-toggle="dropdown" href="#" role="menuitem" target="">{{ menuSections.length ? menuSections[2].label : 'Service & Parts' }}</a>
                  <ul aria-label="Service &amp; Parts" class="dropdown-menu" role="menu">
                    <li
                        v-for="(item, itemIndex) in menuSections[2].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @click="openSideDropdown"><a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle"
                    data-hover="dropdown" data-model-dropdown="" data-section-title="Finance" data-toggle="dropdown"
                    href="#" role="menuitem" target="">{{ menuSections.length ? menuSections[3].label : 'Financing' }}</a>
                  <ul aria-label="Finance" class="dropdown-menu" role="menu">
                    <li
                        v-for="(item, itemIndex) in menuSections[3].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @click="openSideDropdown"><a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle"
                    data-hover="dropdown" data-model-dropdown="" data-section-title="Ownership" data-toggle="dropdown"
                    href="#" role="menuitem" target="">{{ menuSections.length ? menuSections[4].label : 'Research' }}</a>
                  <ul aria-label="Ownership" class="dropdown-menu" role="menu">
                    <li
                        v-for="(item, itemIndex) in menuSections[4].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                  </ul>
                </li>
                <li class="dropdown" role="none" @click="openSideDropdown"><a aria-expanded="false" aria-haspopup="true" class="dropdown-toggle"
                    data-hover="dropdown" data-model-dropdown="" data-section-title="About Us" data-toggle="dropdown"
                    href="#" role="menuitem" target="">{{ menuSections.length ? menuSections[5].label : 'About' }}</a>
                  <ul aria-label="About Us" class="dropdown-menu" role="menu">
                    <li
                        v-for="(item, itemIndex) in menuSections[5].items"
                        :key="itemIndex"
                        role="none"
                      >
                        <a href="#" role="menuitem">{{ item.title }}</a>
                      </li>
                  </ul>
                </li>
              </ul>
              <div class="navbar-socials">
                <div class="social-media-icons"></div>
              </div><a class="close-dropdown-view hide" href="#"><img alt="Go Back"
                  src="https://d2v1gjawtegg5z.cloudfront.net/assets/left-arrow-white-cf25d7bbda1574930ab482b17046d87f0e6dda28bf6f95772b8325219ec3e49d.png"><span>Back</span></a>
            </div>
            <div class="fade-out"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
</script>

<script>
  import clickThroughMobileNavMixin from "../mixins/clickThroughMobileNavMixin";
  export default {
    mixins: [clickThroughMobileNavMixin],
    props: ['images', 'logoURL'],
    data() {
      return {
        // brand: this.$store.state.chosenBrand,
        brandMenuConfig: {
          infiniti: [
            {
              label: 'Shop',
              items: [
                { title: 'New Vehicle Inventory'},
                { title: 'Certified Pre-Owned Inventory'},
                { title: 'Pre-Owned Inventory'},
                { title: 'INFINITI Offers'},
                { title: 'Retailer Specials'}
              ]
            },
            {
              label: 'Discover',
              items: [
                { title: 'Model Research'},
                { title: 'Compare INFINITI Models'}
              ]
            },
            {
              label: 'Service & Parts',
              items: [
                { title: 'Service Center'},
                { title: 'Schedule Service'},
                { title: 'Service Specials'},
                { title: 'Parts Center'},
                { title: 'Order Parts'},
                { title: 'Parts and Accessories Store'},
                { title: 'Parts Specials'},
                { title: 'Tire Store'}
              ]
            },
            {
              label: 'Financing',
              items: [
                { title: 'Finance Center'},
                { title: 'Finance Application'},
                { title: 'Value Your Trade'}
              ]
            },
            {
              label: 'Ownership',
              items: [
                { title: 'INFINITI Premium Care'},
                { title: 'Connected Services'},
                { title: 'Roadside Assistance'},
                { title: 'INFINITI Lease End Experience'}
              ]
            },
            {
              label: 'About',
              items: [
                { title: 'About Us'},
                { title: 'Meet the Staff'},
                { title: 'Contact Us'},
                { title: 'Hours & Directions'}
              ]
            }
          ],
          ford: [
            {
              label: 'New',
              items: [
                { title: 'New Vehicles'},
                { title: 'Everything EV'},
                { title: "What's Your Car Worth"},
                { title: 'Model Research'}
              ]
            },
            {
              label: 'Pre-Owned',
              items: [
                { title: 'Browse Inventory'},
                { title: 'Vehicles Under $15,000'}
              ]
            },
            {
              label: 'Certified Pre-Owned',
              items: [
                { title: 'Browse Certified Inventory'}
              ]
            },
            {
              label: 'Shopping Tools',
              items: [
                { title: 'Reserve Your New Ford'},
                { title: 'Ford Research'},
                { title: "Ford EV Lineup"},
                { title: 'Everything EV'},
                { title: 'New Vehicle Specials'},
                { title: 'Pre-Owned Specials'}
              ]
            },
            {
              label: 'Service & Parts',
              items: [
                { title: 'Service & Parts Center'},
                { title: 'Schedule Service'},
                { title: "Service & Parts Coupons"}
              ]
            },
            {
              label: 'About',
              items: [
                { title: 'Contact'}
              ]
            }
          ],
          default: [
            {
              label: 'New',
              items: [
                { title: 'New Vehicle Inventory' },
                { title: 'Pre-Owned Inventory' },
                { title: 'Reserve Your Vehicle'}
              ]
            },
            {
              label: 'Pre-Owned',
              items: [
                { title: 'Pre-Owned Inventory' },
                { title: 'Vehicles Under $15,000' }
              ]
            },
            {
              label: 'Shopping Tools',
              items: [
                { title: 'Reserve Your Vehicle'},
                { title: 'Model Research'},
                { title: "Shop Our Lineup"},
                { title: 'New Vehicle Specials'},
                { title: 'Pre-Owned Specials'}
              ]
            },
            {
              label: 'Financing',
              items: [
                { title: 'Finance Center' },
                { title: 'Apply for Financing' },
                { title: 'Value Your Trade' }
              ]
            },
            {
              label: 'Service & Parts',
              items: [
                { title: 'Service Center' },
                { title: 'Schedule Service' },
                { title: 'Parts Center' }
              ]
            },
            {
              label: 'About',
              items: [
                { title: 'About Us' },
                { title: 'Contact Us' },
                { title: 'Hours & Directions' }
              ]
            }
          ]
        }
      };
    },
    computed: {
      logoSRC () {
        const brandLogos = {
          mazda: require("../../static/images/common-icons/brand-logos/mazda-more-padding.png"),
          ford: this.images.logoExample[2],
          hyundai: this.images.logoExample[0]
        };
        return brandLogos[this.currentBrand] || this.images.logoExample[1];
      },
      currentBrand () {
        return this.$store.state.chosenBrand
          ? this.$store.state.chosenBrand.toLowerCase()
          : 'none';
      },
      menuSections() {
        const genericBrands = ['hyundai'];
        const fallbackBrand = genericBrands.includes(this.currentBrand) ? 'default' : this.currentBrand;

        return this.brandMenuConfig[fallbackBrand] || [];
      }
    },
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<!-- Application styles -->

<style scoped>
  .skip-navigation {
    position: absolute;
    top: -500px;
    z-index: -1;
    padding: 7px 8px 7px 8px;
    background-color: #fff;
    border: 1px solid #555;
    color: #555;
  }
  .visuallyhidden {
    position: absolute !important;
    overflow: hidden !important;
    clip: rect(0 0 0 0) !important;
    height: 1px !important;
    width: 1px !important;
    margin: -1px !important;
    padding: 0 !important;
    border: 0 !important;
  }
  a[href="#dropdown-search"] {
    font-family: "FontAwesome";
  }
  a[href="#dropdown-search"]::before {
    content: "\F002";
  }
  a[href="#dropdown-search"][aria-expanded="true"]::before {
    content: "";
  }
  #header #dropdown-search {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    padding: 20px 0;
    background-color: #f5f5f5;
  }
  #header #dropdown-search:not(.open) {
      display: none;
  }  
  .navbar-nav {
    list-style: none;
  }
  .hidden {
    display: none;
  }
  .vcenter {
    display:inline-block;
    vertical-align:middle;
    float:none;
  }
  .row-no-gutters [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
  nav.navbar.navbar-inverse.navbar-fixed-top {
    top: 64px;
  }
  #header {
    margin-bottom: 64px;
  }
  .max-w-adjust {
    max-width: 100%;
  }
  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li:not(:last-child) {
    margin-right: 20px;
  }

</style>

<style scoped>  
  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li:nth-last-child(2) > .dropdown-menu,
  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li:nth-last-child(3) > .dropdown-menu {
    left: unset;
    right: 0;
  }
  #header.nav-right-with-contact .container {
    max-width: 100%;
  }
  @media (min-width: 1501px) {
    body #header.nav-right-with-contact .container,
    body .contact-toolbar-dark-component .container {
      width: 1500px;
    }
  }
  @media (max-width: 1500px) {
      #header.nav-right-with-contact .container {
          width: 100% !important;
      }
  }

  .nav-right-with-contact .nav-contact-toolbar::after {
    content: '';
    display: block;
    width: 200vw;
    height: 1px;
    position: absolute;
    left: -100vw;
    bottom: 0;
    background-color: var(--secondary-dark, #646464);
  }

  /* #header.nav-right-with-contact header {
    background-color: #fff;
  } */
  .nav-right-with-contact .container {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .nav-right-with-contact header .container .header-wrapper #desktop-menu>li a {
    display: block;
    padding: 10px 12px;
    line-height: 28px;
    text-decoration: none;
    font-weight: 500;
  }
  #header.nav-right-with-contact .mobile-contact-bar {
    height: fit-content;
  }
  li.dropdown.models-dropdown.open .dropdown-menu.models-dropdown-menu {
    position: absolute;
    top: 79%;
    left: 0;
    right: 0;
  }

  li.dropdown.models-dropdown {
      position: static;
  }
  #desktop-header .search-bar button[aria-label="search text"][type="submit"] {
    border-radius: 0px 3px 3px 0px !important;
  }

  #desktop-header .search-bar .input-search {
    border-radius: 3px 0px 0px 3px !important;
  }
  .vehicle-model-dropdown .models-wrapper {
    overflow-y: scroll;
  }
  @media (min-width: 768px) {
    #header.nav-right-with-contact .dealer-logo {
      max-width: 100%;
      display: block;
      margin: 0 auto;
    }
  }
  @media (max-width: 767px) {
    #header.nav-right-with-contact .dealer-logo {
      max-width: 100%;
      padding-bottom: 10px;
      display: block;
      image-rendering: -webkit-optimize-contrast;
    }
  }

</style>


<style scoped>

  /* Themes */

  .nav-right-with-contact {
    --sokal-icon-chevron-down-sm: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/707/325/original/genesis-chevron-down-bold-sm.png?1703192172);
    --sokal-icon-search-lg: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/713/064/original/genesis-search-bold-lg.png?1703619365);
    --sokal-icon-phone-sm: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/728/285/original/genesis-phone-solid-bold.png?1704738104);
    --sokal-icon-map-marker-sm: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/728/286/original/genesis-geolocation-solid-regular.png?1704738109);
    --text-transform: capitalize;
    --letter-spacing: 0.32px;
    /* --btn-br: var(--sokal-btn-br-{{this.$store.state.chosenBrand}}, 0); */
    --pc: var(--primary-color, #333333);
    --pcd: var(--primary-dark, #000000);
    --pcl: var(--primary-light, #ffffff);
    --text-color: var(--pcl, #ffffff);
    --text-color-hovered: var(--pcl, #ffffff);
    --bg-color-hovered: var(--secondary-color, #ffffff);
    --bg-color: var(--pc, #333333);
    --nav-border-bottom-color: var(--pcd, #000000);
    --side-nav-menu-bg-color: var(--pcd, #000000);
    /* --mobile-hours-bar-border-bottom-color: #d7d7d7; */
  }

  /* .nav-right-with-contact[data-has-color-fill="true"] {
    --text-color: var(--pcl, #ffffff);
    --text-color-hovered: var(--pcd, #333333);
    --bg-color: var(--pcd, #333333);
    --bg-color-hovered: var(--pcl, #ffffff);
    --nav-border-bottom-color: transparent;
    --mobile-hours-bar-border-bottom-color: rgb(255 255 255 / 50%);
  } */

  /* General */

  /* .nav-right-with-contact[data-dark-color-is-primary="true"] {
    --pc: var(--pcd, #000000);
  } */

  .nav-right-with-contact > * {
    -moz-transition: all 0.1s ease;
    -webkit-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }

  .nav-right-with-contact header {
    background-color: #ffffff;
    background-color: var(--bg-color);
    padding: 0 0;
    font-size: 15px;
    font-weight: 400;
    -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .nav-right-with-contact header .container {
    position: static;
  }

  .nav-right-with-contact .nav-toolbar-side {
    display: flex;
    flex-direction: column;
    align-items: end;
    flex-grow: 1;
  }

  .nav-right-with-contact #desktop-logo:hover, 
  .nav-right-with-contact .mobile-dealer-logo:hover {
    cursor: pointer;
  }

  /* Top Contact Toolbar */
  
  .nav-right-with-contact .nav-contact-toolbar {
    float: right;
    white-space: nowrap;
    padding: 20px 0 7px 0;
    min-height: 30px;
    font-size: 10px;
    position: relative;
    z-index: 5555;
    display: block;
    color: #000000;
    color: var(--text-color);
    background-color: #ffffff;
    background-color: var(--bg-color);
  }

  .nav-right-with-contact .navbar-inverse .navbar-nav>li>a {
    color: #000000;
    color: var(--text-color);
  }

  /* .nav-right-with-contact .nav-contact-toolbar a, 
  .nav-right-with-contact .nav-contact-toolbar a:hover, 
  .nav-right-with-contact .nav-contact-toolbar a:active, 
  .nav-right-with-contact .nav-contact-toolbar a:focus {
    color: #000000;
    color: var(--text-color);
    opacity: 0.7;
  } */

  .nav-right-with-contact .nav-contact-toolbar a {
    font-size: 12px;
    font-weight: 400;
    text-transform: none;
    text-transform: var(--text-transform);
    letter-spacing: 0;
    letter-spacing: var(--letter-spacing);
  }

  .nav-right-with-contact .nav-contact-toolbar a:hover, 
  .nav-right-with-contact .nav-contact-toolbar a:active, 
  .nav-right-with-contact .nav-contact-toolbar a:focus {
    /* opacity: 1; */
    text-decoration: none;
  }

  .nav-right-with-contact .nav-contact-toolbar > .row {
    display: flex;
    flex-direction: row;
    padding: 0 12px;
  }

  .nav-right-with-contact .nav-contact-toolbar .phone-link {
    margin-left: 0;
    padding-left: 15px;
    padding-right: 15px;
    border-right: 1px solid;
    border-right-color: #000000;
    border-right-color: var(--text-color);
    border-right-color: #b4b4b4;
  }

  .nav-right-with-contact .nav-contact-toolbar .hours-link, 
  .nav-right-with-contact .nav-contact-toolbar .translate-link {
    margin-left: 15px;
    border-left: 1px solid;
    border-left-color: #000000;
    border-left-color: var(--text-color);
  }

  .nav-right-with-contact .nav-contact-toolbar:not([data-items*="phone"], [data-items*="address"]) .hours-link {
    border-left: none;
  }
  
  .nav-right-with-contact .nav-contact-toolbar[data-items="hours"] .hours-link, 
  .nav-right-with-contact .nav-contact-toolbar[data-items="translate"] .translate-link {
    border-left: none;
  }
  

  /* Desktop Menu */

  .nav-right-with-contact header .container .header-wrapper ul {
    margin: 0;
    border: none;
    border-radius: 0;
    padding: 0;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu {
    display: inline-flex;
    flex-direction: row;
    float: none;
    vertical-align: middle;
    flex-grow: 0;
    padding: 5px 0 10px 0;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li:not(.models-dropdown-sibling) {
    display: inline-block;
    vertical-align: top;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li a {
    display: block;
    padding: 10px 12px;
    line-height: 28px;
    text-decoration: none;
    font-weight: 500;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu .search-bar {
    padding-top: 0;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu>li:nth-last-child(2) > .dropdown-menu, 
  .nav-right-with-contact header .container .header-wrapper #desktop-menu>li:nth-last-child(3) > .dropdown-menu {
    left: unset;
    right: 0;
  }

  .nav-right-with-contact, 
  .nav-right-with-contact .navbar.navbar-inverse, 
  .nav-right-with-contact header, 
  .nav-right-with-contact .nav-contact-toolbar {
    background-color: #ffffff;
    background-color: var(--bg-color);
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    border:0;
  }

  .nav-right-with-contact .navbar.navbar-inverse, 
  .nav-right-with-contact .mobile-contact-bar {
    border-bottom: solid 1px;
    border-bottom-color: #000000;
    border-bottom-color: var(--nav-border-bottom-color);
  }

  .nav-right-with-contact,
  .nav-right-with-contact .mobile-nav-bar .side-nav>li>a,
  .nav-right-with-contact .mobile-nav-bar .navbar-inner>ul>li.dropdown.open>a,
  .nav-right-with-contact .mobile-nav-bar .side-nav>li>ul.dropdown-menu>li>a,
  .nav-right-with-contact .mobile-nav-bar {
    font-size: 13px;
  }

  .nav-right-with-contact header .container .header-wrapper {
    width: 100%;
    white-space: nowrap;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: stretch;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-logo {
    display: flex;
    align-items: center;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-logo a:hover, 
  .nav-right-with-contact header .container .header-wrapper #desktop-logo a:active, 
  .nav-right-with-contact header .container .header-wrapper #desktop-logo a:focus {
    text-decoration: none;
  }

  .nav-right-with-contact #desktop-header .container .header-wrapper #desktop-logo .dealer-logo {
    margin: 0;
    display: inline-block;
    vertical-align: top;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu>li>a {
    position: relative;
    outline: none;
    font-size: 14px;
    padding-top: 0;
    text-transform: none;
    text-transform: var(--text-transform);
    letter-spacing: 0;
    letter-spacing: var(--letter-spacing);
  }

  /*.nav-right-with-contact header .container .header-wrapper #desktop-menu>li>a:after {
    display: block;
    content: " ";
    position: absolute;
    left: 0%;
    bottom: 0;
    width: 0;
    -moz-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    height: 2px;
    background-color: transparent;
  }*/

  .nav-right-with-contact header .container .header-wrapper #desktop-menu>li>a:hover::after, 
  .nav-right-with-contact header .container .header-wrapper #desktop-menu>li>a:focus::after {
    width: 100%;
    background-color: #333333;
    background-color: var(--text-color);
  }

  .nav-right-with-contact .navbar-inverse .navbar-nav>.open>a, 
  .nav-right-with-contact .navbar-inverse .navbar-nav>.open>a:hover, 
  .nav-right-with-contact .navbar-inverse .navbar-nav>li>a:hover, 
  .nav-right-with-contact .navbar-inverse .navbar-nav>.open>a:focus, 
  .nav-right-with-contact .navbar-inverse .navbar-nav>li>a:focus {
    background-color: transparent;
    color: #333333;
    color: var(--text-color);
  }

  .nav-right-with-contact .navbar .dropdown-menu>li>a {
    -moz-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    font-size: 13px;
    color: #333333;
    color: var(--text-color);
  }

  .nav-right-with-contact .navbar .dropdown-menu>li>a:focus {
    background-color: transparent;
  }

  .nav-right-with-contact .navbar .dropdown-menu>li>a:hover,
  .nav-right-with-contact #more-dropdown:hover {
    color: #ffffff;
    color: var(--text-color-hovered);
    background-color: #333333;
    background-color: var(--bg-color-hovered);
  }

  .nav-right-with-contact header .container .header-wrapper ul.dropdown-menu {
    background-color: #ffffff;
    background-color: var(--bg-color);
  }

  /* Search Bar */

  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li:last-of-type {
    position: relative;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu>li>a:hover::after, 
.nav-right-with-contact header .container .header-wrapper #desktop-menu>li>a:focus::after {
  background-color: transparent;
}

.nav-right-with-contact #dropdown-search .search-bar {
  border-color: rgb(255 255 255 / 20%);
}

.nav-right-with-contact header .container .header-wrapper #desktop-menu > li > a[href="#dropdown-search"], 
.nav-right-with-contact .search-bar .search-submit-btn .fa-search {
  color: transparent;
  background-size: 22px auto;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-filter: invert(1);
  filter: invert(1);
}

.nav-right-with-contact header .container .header-wrapper #desktop-menu > li > a[href="#dropdown-search"]:not(.close-search), 
.nav-right-with-contact .search-bar .search-submit-btn .fa-search {
  background-image: var(--sokal-icon-search-lg);
}

.nav-right-with-contact header .container .header-wrapper #desktop-menu > li > a[href="#dropdown-search"].close-search {
  background-image: var(--sokal-icon-close-lg);
}

.nav-right-with-contact .search-bar .search-submit-btn .fa-search {
  width: 100%;
  height: 100%;
}

.nav-right-with-contact .search-bar .search-submit-btn {
  width: 50px;
}

  /* Nav Vehicle Models */
  
  .nav-right-with-contact .vehicle-model-dropdown .model-text h3 {
    color: #000000;
    color: var(--pcd);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .vehicle-model-dropdown .models-wrapper .model-container .model-text, 
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .vehicle-model-dropdown .models-wrapper .model-container .model-text h3 {
    letter-spacing: 0;
    letter-spacing: var(--letter-spacing);
    font-family: var(--heading-text);
  }

  .nav-right-with-contact .vehicle-model-dropdown .models-wrapper .model-container .model-text h3 {
    text-transform: none;
    text-transform: var(--text-transform);
  }

  .nav-right-with-contact .vehicle-model-dropdown .models-wrapper .model-container img {
    max-height: 110px;
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .vehicle-model-dropdown .search-btns .btn {
    color: #ffffff;
    color: var(--pcl);
    background-color: #333333;
    background-color: var(--pc);
    border: 3px solid;
    border-color: #333333;
    border-color: var(--pc);
    font-size: 16px;
    text-transform: none;
    text-transform: var(--text-transform);
    letter-spacing: 0;
    letter-spacing: var(--letter-spacing);
    -moz-transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    border-radius: var(--brand-br, 4px) !important;
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .vehicle-model-dropdown .search-btns .btn:hover,
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .vehicle-model-dropdown .search-btns .btn:active,
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .vehicle-model-dropdown .search-btns .btn:focus {
    text-decoration: none;
    background-color: var(--pcl);
    border-color: var(--pc);
    color: var(--pc);
  }

  
  /* Mobile Nav */

  .nav-right-with-contact .mobile-dealer-logo {
    width: 100%;
    justify-content: center;
    max-width: unset;
    padding-left: 10px;
    padding-right: 10px;
  }

  .nav-right-with-contact .mobile-dealer-logo::after {
    display: flex;
    font-size: 13px;
  }

  .nav-right-with-contact .mobile-dealer-logo, 
  .nav-right-with-contact .mobile-dealer-logo > a {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .nav-right-with-contact .mobile-dealer-logo .dealer-logo {
    max-height: 100%;
  }

  .nav-right-with-contact .mobile-contact-bar .contact-info {
    float: right;
    margin: 0;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
  }

  .nav-right-with-contact .mobile-contact-bar .contact-info .contact-item:hover {
    text-decoration: none;
    font-weight: 600;
    cursor: pointer;
  }

  .nav-right-with-contact .mobile-contact-bar .contact-info .contact-item a:hover {
    text-decoration: none;
  }

  .nav-right-with-contact .mobile-contact-bar {
    background-color: #ffffff;
  }

  .nav-right-with-contact .mobile-contact-bar .toggle-side-menu {
    height: 100%;
    float: left;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  #header.nav-right-with-contact .mobile-contact-bar .mobile-menu-toggle {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 0;
    padding-bottom: 0;
  }

  .nav-right-with-contact .mobile-contact-bar .mobile-menu-toggle .icon-bar {
    height: 1px;
    margin-top: 7px;
    background: #000000;
    background: var(--text-color);
  }

  .nav-right-with-contact .click-through-mobile-contact-bar .mobile-menu-toggle .icon-bar {
    background-color: #000000;
    background-color: var(--text-color);
  }

  #header.nav-right-with-contact .mobile-contact-bar .mobile-menu-toggle > span:nth-child(2) {
    margin-top: 0;
  }

  .nav-right-with-contact [class*="mobile-contact-bar"] {
    background: var(--bg-color);
  }

  .nav-right-with-contact [class*="mobile-contact-bar"] .contact-info .contact-item {
    color: #000000;
    color: var(--text-color);
  }

  .nav-right-with-contact .mobile-contact-bar .contact-info .contact-item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .nav-right-with-contact .mobile-nav-bar .side-nav ul,
  .nav-right-with-contact .mobile-nav-bar .side-nav li,
  .nav-right-with-contact .mobile-nav-bar .side-nav a {
    outline: none !important;
  }

  .nav-right-with-contact [class*="mobile-contact-bar"] .contact-info {
    width: 60px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
  }

  .nav-right-with-contact [class*="mobile-contact-bar"] .contact-info .contact-item {
    margin-right: 0;
  }

  .nav-right-with-contact .click-through-mobile-nav-bar .search-bar .input-search::placeholder {
    color: rgba(255, 255, 255, 0.8);
  }

  .nav-right-with-contact .click-through-mobile-nav-bar {
    background: #000000;
    background: var(--side-nav-menu-bg-color);
  }

  .nav-right-with-contact .click-through-mobile-nav-bar .navbar-outer .navbar-inner .side-nav li a {
    text-transform: none;
    text-transform: var(--text-transform);
    letter-spacing: 0;
    letter-spacing: var(--letter-spacing);
  }

  .nav-right-with-contact .click-through-mobile-nav-bar .fade-out {
    background: -moz-linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, var(--side-nav-menu-bg-color) 99%, var(--side-nav-menu-bg-color) 100%);
    background: -webkit-linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, var(--side-nav-menu-bg-color) 99%, var(--side-nav-menu-bg-color) 100%);
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, var(--side-nav-menu-bg-color) 99%, var(--side-nav-menu-bg-color) 100%);
  }

  /* Nav Hours */

  .nav-right-with-contact .nav-contact-toolbar .toolbar-address {
    width: unset;
    flex-grow: 1;
    padding: 0;
  }

  .nav-right-with-contact .nav-contact-toolbar .toolbar-address a {
    margin-left: 15px;
    padding-left: 15px;
    padding-right: 0;
    border-left: 1px solid;
    border-left-color: #000000;
    border-left-color: var(--text-color);
  }

  .nav-right-with-contact .nav-contact-toolbar:not([data-items*="phone"]) .toolbar-address a {
    border-left: none;
  }

  .nav-right-with-contact .mobile-nav-utility-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 3px 0;
    font-size: 12px;
    background-color: #ffffff;
    background-color: var(--bg-color);
    border-bottom: solid 1px;
    border-bottom-color: #d7d7d7;
    border-bottom-color: var(--mobile-hours-bar-border-bottom-color, #d7d7d7);
  }

  .nav-right-with-contact .mobile-nav-utility-bar a {
    color: #000000;
    color: var(--text-color);
  }

  .nav-right-with-contact .mobile-nav-utility-bar a:hover, 
  .nav-right-with-contact .mobile-nav-utility-bar a:active, 
  .nav-right-with-contact .mobile-nav-utility-bar a:focus {
    text-decoration: none;
  }

  /* Nav Translate */

  .nav-right-with-contact .toolbar-select-language {
    position: relative;
  }

  .nav-right-with-contact .google-translate-widget-container {
    visibility: hidden;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }

  .nav-has-google-translate iframe.VIpgJd-ZVi9od-xl07Ob-OEVmcd.skiptranslate {
    z-index: 99999999;
  }

  .nav-right-with-contact .mobile-nav-utility-bar > [class*="toolbar-"]:nth-child(2) {
    margin-left: 10px;
  }

  html[class*="translated"] .nav-has-google-translate {
    top: 0px !important;
  }

  html[class*="translated"] .nav-has-google-translate iframe.VIpgJd-ZVi9od-ORHb-OEVmcd {
    display: none;
  }

  /* Other */

  .nav-right-with-contact ~ .mobile-shortcut-btns {
    padding-top: 20px;
  }

  .nav-right-with-contact .mobile-contact-bar {
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .nav-right-with-contact [class*="mobile-contact-bar"][data-has-utility-bar-content="true"] {
    height: 93px;
  }

  .nav-right-with-contact [class*="mobile-contact-bar"][data-has-utility-bar-content="true"] > *:not(.mobile-nav-utility-bar) {
    padding-top: 23px
  }

  #header.nav-right-with-contact [class*="mobile-contact-bar"] .contact-info .contact-item[data-has-call-text="true"] .call-now-mobile-btn {
    display: inline-block !important;
    padding: 0 5px 0 0;
    background-color: transparent;
    color: #000000;
    color: var(--text-color);
  }

  .nav-right-with-contact [class*="mobile-contact-bar"] .contact-info .contact-item[data-has-call-text="true"] .fa-phone {
    display: none !important;
  }

  @media (max-width: 767px) {
    .nav-right-with-contact [class*="mobile-contact-bar"][data-has-utility-bar-content="true"] {
      height: 79px;
    }

    .nav-right-with-contact [class*="mobile-contact-bar"][data-has-utility-bar-content="true"] > *:not(.mobile-nav-utility-bar) {
      padding-top: 24px
    }
  }

  /* Show Mobile Nav */

  #header.nav-right-with-contact.show-mobile-nav > .hidden-sm.hidden-xs {
    display: none !important;
  }

  #header.nav-right-with-contact.show-mobile-nav > .visible-sm.visible-xs{
    display: block !important;
  }

  /* Mobile Nav */
  
  .nav-right-with-contact {
    --sokal-mobile-nav-height: 70px;
    --sokal-mobile-nav-height-offset: 26px;
  }

  /* Media Queries */

  @media (min-width: 1501px) {

    #header.nav-right-with-contact .container {
      min-width: 1170px;
      width: 1500px;
    }

    .nav-right-with-contact .header-wrapper {
      margin: auto;
      width: fit-content;
    }

  }

  @media (max-width: 1500px) {

    #header.nav-right-with-contact .container {
      width: 100%;
    }

  }

  @media (min-width: 768px) and (max-width: 1199px) {
    
    #header.nav-right-with-contact > .hidden-sm.hidden-xs {
      display: none !important;
    }

    #header.nav-right-with-contact > .visible-sm.visible-xs{
      display: block !important;
    }

    #header.nav-right-with-contact .mobile-dealer-logo .dealer-logo {
      max-height: 70px;
    }

  }

  @media (max-width: 767px) {
    .nav-right-with-contact .mobile-dealer-logo .dealer-logo {
      max-height: 55px;
    }

    .nav-right-with-contact .mobile-contact-bar .contact-info .contact-item {
      margin-right: 7px;
    }

    .nav-right-with-contact .sidr .side-nav .open .dropdown-menu > li > a {
      padding: 0 25px 0 25px;
    }

    .mobile-contact-bar .contact-info .contact-item .fa {
      font-size: 20px;
    }

    .mobile-contact-bar .mobile-menu-toggle {
      padding-top: 12px;
    }

  }

  @media (max-width: 575px) {

    .nav-right-with-contact .mobile-contact-bar .contact-info {
      width: 60px;
      margin-right: 0;
    }

    .nav-right-with-contact .mobile-contact-bar .mobile-dealer-logo img {
      padding: 3px;
    }

  }

  @media (max-width: 480px) {

    #header.nav-right-with-contact .mobile-dealer-logo .dealer-logo {
      max-width: 230px;
    }

  }

  @media (max-width: 400px) {
    
    #header.nav-right-with-contact .mobile-dealer-logo .dealer-logo {
      max-width: 145px;
    }

  }

  /* Dealer Name CSS / Alt Logo Format */

  .nav-right-with-contact #desktop-logo::after, 
  .nav-right-with-contact .mobile-dealer-logo::after {
    justify-content: center;
    align-items: center;
    padding-left: 1.3rem;
    white-space: normal;
    color: #333333;
    color: var(--text-color);
    border-left: 1px solid #333333;
    border-left: 1px solid var(--text-color);
    text-transform: none;
    text-transform: var(--text-transform);
    letter-spacing: 0;
    letter-spacing: var(--letter-spacing);
  }

  .nav-right-with-contact #desktop-logo::after {
    display: inline-flex;
    font-size: 18px;
  }

  .nav-right-with-contact[data-has-color-fill="true"] #desktop-logo::after, 
  .nav-right-with-contact[data-has-color-fill="true"] .mobile-dealer-logo::after {
    color: #ffffff;
    border-left-color: #ffffff;
  }

  .nav-right-with-contact[data-apply-dealer-name-css="true"] #desktop-logo::after, 
  .nav-right-with-contact[data-apply-dealer-name-css="true"] .mobile-dealer-logo::after {
    content: '#{current_website.dealer_name}';
  }

  .nav-right-with-contact[data-apply-dealer-name-css="true"] .dealer-logo {
    display: none !important;
  }

  .nav-right-with-contact[data-apply-dealer-name-css="true"] #desktop-logo > a, 
  .nav-right-with-contact[data-apply-dealer-name-css="true"] .mobile-dealer-logo > a {
    display: inline-block;
    background-image: url("#{current_website.logo&.url}");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .nav-right-with-contact[data-apply-dealer-name-css="true"] #desktop-logo > a, 
  .nav-right-with-contact[data-apply-dealer-name-css="true"] #desktop-logo::after, 
  .nav-right-with-contact[data-apply-dealer-name-css="true"] .mobile-dealer-logo > a, 
  .nav-right-with-contact[data-apply-dealer-name-css="true"] .mobile-dealer-logo::after {
    max-height: 100%;
  }

  .nav-right-with-contact[data-apply-dealer-name-css="true"] #desktop-logo > a {
    width: 100px;
    height: 100px;
  }

  .nav-right-with-contact[data-apply-dealer-name-css="true"] .mobile-dealer-logo > a {
    width: 55px;
    height: 55px;
  }

  .nav-right-with-contact[data-apply-dealer-name-css="true"] #desktop-logo::after {
    height: 40px;
  }

  @media (max-width: 1500px) {
    
    .nav-right-with-contact #desktop-logo::after {
      font-size: 1.2vw;
    }

  }

  /* Cycle Nav Hours */

  @keyframes mobileUtilityBarHoursFade {
    20% {
      opacity: 1;
    }
    
    80% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
  
  @media (min-width: 1200px) {
    
    .show-mobile-nav.nav-has-google-translate iframe.VIpgJd-ZVi9od-xl07Ob-OEVmcd.skiptranslate {
      left: 50% !important;
      transform: translateX(-50%) !important;
      top: 26px !important;
    }

  }

  @media (max-width: 1199px) {

    .nav-has-google-translate iframe.VIpgJd-ZVi9od-xl07Ob-OEVmcd.skiptranslate {
      left: 50% !important;
      transform: translateX(-50%) !important;
      top: 26px !important;
    }

  }

  @media (max-width: 575px) {

    .nav-has-google-translate iframe.VIpgJd-ZVi9od-xl07Ob-OEVmcd.skiptranslate {
      left: unset !important;
      transform: none !important;
      right: 10px !important;
    }

    .nav-right-with-contact .mobile-nav-utility-bar {
      padding-left: 20px;
      padding-right: 10px;
    }
    
    .nav-right-with-contact .mobile-nav-utility-bar:not([data-items-count="1"]) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .nav-right-with-contact .mobile-nav-utility-bar.cycle-hours .toolbar-hours .nav-hour .category-delimiter {
      display: none;
    }
    
    .nav-right-with-contact .mobile-nav-utility-bar.cycle-hours .toolbar-hours .nav-hour:not(.active) {
      display: none;
    }

    .nav-right-with-contact .mobile-nav-utility-bar[data-show-multiple-hours="true"] .toolbar-hours {
      opacity: 0;
      animation: 5s ease 0s infinite normal forwards running mobileUtilityBarHoursFade;
    }

  }

  @media (max-width: 300px) {

    .nav-has-google-translate iframe.VIpgJd-ZVi9od-xl07Ob-OEVmcd.skiptranslate {
      right: 5px !important;
    }

    .nav-right-with-contact .mobile-nav-utility-bar {
      padding-left: 5px;
      padding-right: 5px;
    }

  }
</style>




<!-- CSS FROM V EXTENDED TOOLBAR SPECIFICLY -->

<style scoped>

.nav-right-with-contact header .container .header-wrapper #desktop-menu > li.dropdown > a::after {
  content: '';
  display: block;
  pointer-events: none;
  position: absolute;
  left: unset;
  bottom: unset;
  top: 50%;
  right: 0%;
  width: 10px;
  height: 15px;
  opacity: 0.4;
  transform: translateY(-50%);
  -webkit-filter: invert(1);
  filter: invert(1);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: var(--sokal-icon-chevron-down-sm);
}

#nav-right-with-contact-v-extended-toolbar {
  padding-bottom: 15px;
}

#nav-right-with-contact-v-extended-toolbar [class*="mobile-contact-bar"] {
  /* top: 64px !important; */
  margin: 26px auto 0 auto;
  margin: var(--sokal-mobile-nav-height-offset, 26px) auto 0 auto;
  padding: 0 20px;
  -webkit-box-shadow: none;
  box-shadow: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact [class*="mobile-contact-bar"][data-has-utility-bar-content="true"] {
  height: 70px;
  height: var(--sokal-mobile-nav-height, 70px);
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact [class*="mobile-contact-bar"][data-has-utility-bar-content="true"] > *:not(.mobile-nav-utility-bar) {
  padding-top: 0;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .mobile-nav-utility-bar {
  position: fixed;
  top: 0;
  padding-left: 30px;
  padding-right: 30px;
  border-bottom: none;
}

#nav-right-with-contact-v-extended-toolbar [class*="mobile-contact-bar"] .mobile-menu-toggle {
  align-items: flex-start;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact [class*="mobile-contact-bar"] .mobile-menu-toggle .icon-bar:nth-child(2) {
  display: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .click-through-mobile-contact-bar .contact-info {
  height: 45px;
}

#nav-right-with-contact-v-extended-toolbar [class*="mobile-contact-bar"] .contact-item .fa-map-marker::before {
  content: "\f278";
  font-size: 21px;
  margin-left: 1.5vw;
}

#nav-right-with-contact-v-extended-toolbar .navbar-socials .social-media-icons {
  display: flex;
  flex-flow: row wrap;
  justify-content: start;
}

#nav-right-with-contact-v-extended-toolbar .navbar-socials-original {
  padding: 0 12px;
}

#nav-right-with-contact-v-extended-toolbar .navbar-socials .social-media-icons .social-media-link {
  margin-left: 15px;
}

#nav-right-with-contact-v-extended-toolbar .navbar-socials .social-media-icons .social-media-link:first-child {
  margin-left: 0;
}

#nav-right-with-contact-v-extended-toolbar .social-media-icons .social-media-link:hover {
  color: #333333;
  color: var(--pcl);
}

#nav-right-with-contact-v-extended-toolbar .social-media-icons .social-media-link:focus {
  outline: none;
}

#nav-right-with-contact-v-extended-toolbar .navbar-socials .custom-fa-icon {
  margin-top: 11px !important;
  font-size: 0.8em;
}

@media (max-width: 300px) {
  #nav-right-with-contact-v-extended-toolbar [class*="mobile-contact-bar"] {
    padding-right: 8px;
  }
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact #desktop-header {
  position: relative;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact #desktop-header > .container {
  padding: 7px 20px;
  margin: 26px auto 0 auto;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar, 
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .mobile-nav-utility-bar {    
  position: absolute;
  top: -26px;
  left: 0;
  width: 100%;
  min-height: unset;
  padding: 8px 0;
  line-height: 6px;
  background-color: #000000;
  background-color: var(--pcd);
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar {
  text-align: right;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar > .row {
  max-width: 1500px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar a, 
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .mobile-nav-utility-bar a {
  --text-color: var(--pcl);
  color: #b4b4b4;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar a, 
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .mobile-nav-utility-bar a {
  font-size: 10px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar a:hover, 
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .mobile-nav-utility-bar a:hover {
  color: #ffffff;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .navbar #desktop-phone-menu .dropdown-menu>li>a:hover,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact #desktop-phone-menu #more-dropdown:hover,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .navbar #desktop-hours-menu .dropdown-menu>li>a:hover,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact #desktop-hours-menu #more-dropdown:hover,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .navbar #desktop-social-menu .dropdown-menu>li>a:hover,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact #desktop-social-menu #more-dropdown:hover {
  background-color: #333333;
  background-color: var(--pcd);
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact header .container .header-wrapper #desktop-menu > li > a {
  padding: 10px 25px 10px 15px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact header .container .header-wrapper #desktop-phone-menu .dropdown-menu,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact header .container .header-wrapper #desktop-hours-menu .dropdown-menu,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact header .container .header-wrapper #desktop-social-menu .dropdown-menu {
  background-color: #000000;
  background-color: var(--pcd);
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar #desktop-hours-menu .all-hours-dropdown {
  display: flex;
  flex-flow: column nowrap;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar #desktop-hours-menu .all-hours-dropdown .category-delimiter {
  display: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar #desktop-phone-menu .phone-link,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar #desktop-hours-menu .nav-hour {
  padding: 5px 6px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] .toolbar-phone-numbers .phone-link:hover,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] .toolbar-phone-numbers .phone-link:active,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] .toolbar-phone-numbers .phone-link:focus {
  color: #ffffff;
  text-decoration: none;
  border-right-color: #b4b4b4;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] .phone-link:hover .phone-label,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] .phone-link:hover .phone-number,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] a:active .phone-label,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] a:active .phone-number, 
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] a:focus .phone-label,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] a:focus .phone-number {
  color: #b4b4b4;
  text-decoration: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar #desktop-phone-menu .dropdown-toggle,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar #desktop-hours-menu .dropdown-toggle,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar #desktop-social-menu .dropdown-toggle {
  padding: 0 15px;
}

#nav-right-with-contact-v-extended-toolbar .nav-contact-toolbar[data-extended-version="true"] .vcenter .dropdown-toggle {
  line-height: 6px;
}

#nav-right-with-contact-v-extended-toolbar .nav-contact-toolbar[data-extended-version="true"] .dropdown:hover .dropdown-menu {
  display: block;
}

#nav-right-with-contact-v-extended-toolbar .nav-contact-toolbar[data-extended-version="true"] .vcenter .parent-dropdown .dropdown-toggle {
  pointer-events: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"] .toolbar-address,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-hours-dropdown="false"] .toolbar-hours {
  padding-right: 15px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-hours-dropdown="true"][data-translate-enabled="true"] .toolbar-select-language .fa-globe {
  margin-left: 15px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-hours-dropdown="true"] .toolbar-select-language .translate-link {
  margin-left: 0;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact header .container .header-wrapper #desktop-phone-menu a.dropdown-toggle:focus,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact header .container .header-wrapper #desktop-hours-menu a.dropdown-toggle:focus,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact header .container .header-wrapper #desktop-social-menu a.dropdown-toggle:focus {
  outline: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar .toolbar-socials .social-media-icons .dropdown-toggle {
  margin-left: 0;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar .phone-link {
  border-right: 1px solid;
  border-right-color: #ffffff;
  border-right-color: var(--pcl);
  border-right-color: #b4b4b4;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="true"] .phone-link {
  border-right: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="true"][data-matching-phones-dropdown-check="true"] #desktop-phone-menu .dropdown-menu .dropdown:nth-child(n+2) {
  display: none;
}


#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-hours-dropdown="false"] .hours-link,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-translate-enabled="true"] .translate-link {
  border-left: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar .toolbar-address a {
  border-left: none;
  margin-left: 0;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"] .vcenter:not(.toolbar-address) {
    border-left: 1px solid;
    border-color: #ffffff;
    border-color: var(--pcl);
    border-left-color: #b4b4b4;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"] .vcenter:first-child {
  border-left: none;
  border-right: 1px solid;
  border-color: #ffffff;
  border-color: var(--pcl);
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="false"] .vcenter:first-child,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-address-enabled="false"] .toolbar-phone-numbers,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-address-enabled="false"][data-phone-dropdown="true"] .phone-link,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-address-enabled="false"][data-phone-dropdown="false"] .phone-link:last-child {
  border-right: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar .translate-link .fa-caret-down {
  margin-right: 15px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar .toolbar-socials {
  margin-right: 15px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-social-dropdown="true"] .toolbar-socials {
  margin: 0;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-social-dropdown="true"] .toolbar-socials .social-media-link svg {
  width: 9px;
  margin-top: 1px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar .social-media-icons .social-media-link {
  margin-top: 0;
  margin-bottom: 0;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar .social-media-icons .social-media-link {
  margin-left: 12px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="true"] #desktop-phone-menu .dropdown-menu {
  min-width: auto;
  padding: 3px 10px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-hours-dropdown="true"] #desktop-hours-menu .dropdown-menu {
  min-width: auto;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-hours-dropdown="true"] #desktop-hours-menu .dropdown-menu .all-hours-dropdown {
  padding: 3px 10px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-social-dropdown="true"] .toolbar-socials #desktop-social-menu .dropdown .dropdown-menu .dropdown {
  width: 50%;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-social-dropdown="true"] .toolbar-socials #desktop-social-menu .social-media-link {
  margin-left: 0;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-hours-dropdown="true"] #desktop-hours-menu .dropdown {
  list-style: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-social-dropdown="true"] .toolbar-socials .dropdown-menu .dropdown {
  min-height: 20px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-social-dropdown="true"] #desktop-social-menu .dropdown.open .dropdown-menu,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-social-dropdown="true"] #desktop-social-menu .dropdown:hover .dropdown-menu {
  display: flex;
  flex-flow: row wrap;
  min-width: 100px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-social-dropdown="false"] .toolbar-socials .custom-fa-icon {
  font-size: 8px;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-address-enabled="false"][data-hours-dropdown="false"][data-phone-dropdown="false"][data-translate-enabled="false"][data-social-dropdown="true"] .toolbar-socials,
#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-address-enabled="false"][data-hours-dropdown="true"][data-phone-dropdown="false"][data-translate-enabled="false"][data-social-dropdown="false"] .toolbar-hours {
  border-left: none;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .nav-contact-toolbar[data-extended-version="true"][data-phone-dropdown="true"][data-address-enabled="false"][data-hours-dropdown="false"][data-translate-enabled="false"][data-social-dropdown="false"] #desktop-phone-menu .dropdown-menu {
  left: -45%;
}

#nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-has-hours-display="false"] > .visible-sm.visible-xs > .nav-height {
  margin-bottom: 0;
}

/* #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact > .visible-sm.visible-xs .mobile-dealer-logo > a {
  width: 100px;
} */

@media (max-width: 1199px) {

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact [class*="mobile-contact-bar"][data-has-utility-bar-content="false"][data-mobile-hours-should-display="false"] {
    margin-top: 0;
    height: 70px;
  }
  #header {
    margin-bottom: 0;
  }

}

@media (min-width: 576px) and (max-width: 1200px) {

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .mobile-nav-utility-bar .nav-hour:nth-child(n+4) {
    display: none;
  }

}

@media (max-width: 575px) {

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact .mobile-nav-utility-bar {
    padding: 8px 20px;
  }
  
}

@media (min-width: 960px) {
  #nav-right-with-contact-v-extended-toolbar [class*="mobile-contact-bar"],
  nav.navbar.navbar-inverse.navbar-fixed-top {
      top: 64px !important;
    }
  }
@media (min-width: 583px) and (max-width: 959px) {
  .build-default #nav-right-with-contact-v-extended-toolbar [class*="mobile-contact-bar"],
  .build-default nav.navbar.navbar-inverse.navbar-fixed-top {
    top: 48px !important;
  }
}
@media (max-width: 582px) {
  .build-default #nav-right-with-contact-v-extended-toolbar [class*="mobile-contact-bar"],
  .build-default nav.navbar.navbar-inverse.navbar-fixed-top {
    top: 56px !important;
  }
}
@media (min-width: 769px) and (max-width: 959px) {
  .build-resize #nav-right-with-contact-v-extended-toolbar [class*="mobile-contact-bar"],
  .build-resize nav.navbar.navbar-inverse.navbar-fixed-top {
    top: 48px !important;
  }
}
@media (max-width: 768px) {
  .build-resize #nav-right-with-contact-v-extended-toolbar [class*="mobile-contact-bar"],
  .build-resize nav.navbar.navbar-inverse.navbar-fixed-top {
    top: 56px !important;
  }
}
</style>













<style scoped>.vehicle-model-dropdown .dropdown-container {
  overflow-y: auto;
  background: #fff;
  width: 100%;
}
.vehicle-model-dropdown .dropdown-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
}
.vehicle-model-dropdown .mega-menu-reverse {
  flex-flow: row-reverse nowrap;
}
.vehicle-model-dropdown .models-wrapper {
  position: relative;
  padding: 15px 0 30px;
  height: 100%;
  max-width: 1400px;
  margin: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  justify-content: center;
}
.vehicle-model-dropdown .models-wrapper .model-container {
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 20%;
  -moz-box-flex: 0;
  -moz-flex: 0 0 20%;
  flex: 0 0 20%;
  -ms-flex: 0 0 20%;
  padding: 5px 5px 15px;
  max-height: 200px;
  max-width: 240px;
}
.vehicle-model-dropdown .models-wrapper .model-container a {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px 0px;
}
.vehicle-model-dropdown .models-wrapper .model-container a:hover,
.vehicle-model-dropdown .models-wrapper .model-container a:active,
.vehicle-model-dropdown .models-wrapper .model-container a:focus {
  text-decoration: none;
  background: transparent;
  color: inherit;
}
.vehicle-model-dropdown .search-column, 
.vehicle-model-dropdown .model-column  {
  display: inline-block;
}
.vehicle-model-dropdown .model-column {
  max-height: 82vh;
  width: 100%;
  overflow-y: scroll;
}
.vehicle-model-dropdown .models-wrapper .model-container .model-text {
  letter-spacing: .159em;
  text-align: center;
  margin-bottom: auto;
  line-height: initial;
  padding-bottom: 15px;
}
.vehicle-model-dropdown .model-text h3 {
  color: black;
  font-weight: 300;
  font-size: 15px;
  margin: 10px auto 5px;
}
.vehicle-model-dropdown .vehicles-count {
  color: grey;
  font-weight: 500;
  font-size: 12px;
}
.vehicle-model-dropdown .search-column {
  padding-right: calc(50% - 720px);
  background: #f5f5f5;
}
.vehicle-model-dropdown .mega-menu-reverse .search-column {
  padding-right: 0;
  padding-left: calc(50% - 720px);
}
.vehicle-model-dropdown .search-btns {
  width: 100%;
  padding: 30px 20px;
  height: 100%;
}
.vehicle-model-dropdown .search-btns .btn {
  margin: 10px auto 15px;
  min-width: 300px;
  max-width: 340px;
  display: block;
  background-color: #23395d;
  color: #fff;
  padding: 12px 15px;
  text-transform: uppercase;
  text-decoration: none;
}
.vehicle-model-dropdown .models-wrapper .model-container img {
  max-height: 80px;
  max-width: 180px;
  width: auto !important;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  display: block;
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}
.vehicle-model-dropdown .models-wrapper .model-container a:hover img {
  transform: scale(1.05);
}
</style>








<!-- MOBILE NAV -->

<style scoped>
  .click-through-mobile-contact-bar {
    background: #fff;
    height: 70px;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 9999999;
    display: flex;
    align-items: center;
    -webkit-box-shadow: -10px 0 20px -10px rgba(0, 0, 0, 0.1);
    box-shadow: -1px 0 15px -5px rgba(0, 0, 0, 0.16);
  }
  .click-through-mobile-contact-bar .mobile-menu-toggle .icon-bar {
    display: flex;
    width: 25px;
    height: 2px;
    border-radius: 1px;
    margin-top: 6px;
    width: 20px;
    padding: 1px;
    height: 1px;
    border-radius: 50px;
    background-color: var(--text-color);
  }
  .click-through-mobile-contact-bar .mobile-menu-toggle .icon-label {
    display: none;
  }
  .click-through-mobile-contact-bar .contact-info .contact-item .fa {
    margin-right: 0.1em;
  }
  .nav-right-with-contact [class*="mobile-contact-bar"] .fa-phone {
    color: transparent !important;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    -webkit-filter: invert(1);
    filter: invert(1);
  }
  .nav-right-with-contact [class*="mobile-contact-bar"] .fa-phone {
    background-image: var(--sokal-icon-phone-sm);
  }
  /* .nav-right-with-contact [class*="mobile-contact-bar"] .fa-map-marker {
    background-image: var(--sokal-icon-map-marker-sm);
  } */
  .click-through-mobile-contact-bar .contact-info .contact-item {
    display: inline-block;
    vertical-align: middle;
    color: #000;
    margin-right: 0.5em;
  }
  .mobile-sales-phone {
    font-size: 2em;
  }
  .mobile-get-directions {
    font-size: 1.25em;
  }
  /* .nav-right-with-contact .mobile-dealer-logo > a {
    margin-left: 35px;
  } */
</style>











<style scoped>

/* INFINITI STYLES */

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="infiniti"] .nav-contact-toolbar,
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="infiniti"] .mobile-nav-utility-bar {
    background-color: var(--pc, #020b24);
  }

  #desktop-header #desktop-logo > a, 
  .mobile-dealer-logo > a {
    width: 250px;
    height: 50px;
    display: inline-block;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  /* FORD STYLES */

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] {
    --text-color: var(--pcd, #333333);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] .nav-contact-toolbar, #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] .mobile-nav-utility-bar {
    background-color: var(--pc);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] .nav-contact-toolbar a,
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] .mobile-nav-utility-bar a {
    color: var(--pcl);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] .nav-contact-toolbar[data-extended-version="true"] [class*="toolbar-"] a:hover,
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] .nav-contact-toolbar[data-extended-version="true"] [class*="toolbar-"] a:active,
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] .nav-contact-toolbar[data-extended-version="true"] [class*="toolbar-"] a:focus {
    opacity: 0.7;
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] header {
    --bg-color: var(--pcl);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] .navbar .dropdown-menu>li>a:hover,  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] #more-dropdown:hover {
    --bg-color-hovered: var(--pc, #000000);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] header .container .header-wrapper #desktop-menu > li > a[href="#dropdown-search"]:not(.close-search) {
    color: var(--pc);
    background-image: none;
    filter: none;
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] [class*="mobile-contact-bar"] {
    background: var(--pcl);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="ford"] [class*="mobile-contact-bar"] .fa-phone {
    filter: none;
  }

  /* HYUNDAI STYLES */
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] {
    --text-color: var(--pcd, #333333);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] .nav-contact-toolbar, #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] .mobile-nav-utility-bar {
    background-color: var(--pc);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] .nav-contact-toolbar a,
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] .mobile-nav-utility-bar a {
    color: var(--pcl);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] .nav-contact-toolbar[data-extended-version="true"] [class*="toolbar-"] a:hover,
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] .nav-contact-toolbar[data-extended-version="true"] [class*="toolbar-"] a:active,
  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] .nav-contact-toolbar[data-extended-version="true"] [class*="toolbar-"] a:focus {
    opacity: 0.7;
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] header {
    --bg-color: var(--pcl);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] .navbar .dropdown-menu>li>a:hover,  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] #more-dropdown:hover {
    --bg-color-hovered: var(--pc, #000000);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] header .container .header-wrapper #desktop-menu > li > a[href="#dropdown-search"]:not(.close-search) {
    color: var(--pc);
    background-image: none;
    filter: none;
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] [class*="mobile-contact-bar"] {
    background: var(--pcl);
  }

  #nav-right-with-contact-v-extended-toolbar .nav-right-with-contact[data-site-brand="hyundai"] [class*="mobile-contact-bar"] .fa-phone {
    filter: none;
  }
</style>









<style>

/* ADJUST SUBNAV HEIGHT WHEN EXTENDED TOOLBAR ABOVE */
  [data-component="Nav Right With Contact V Extended Toolbar"] + [data-component="Sub Nav Links"],
  [data-component="Nav Right With Contact V Extended Toolbar"] + [data-component="Search Bar"],
  [data-component="Nav Right With Contact V Extended Toolbar"] + [data-component="Contact Toolbar Dark"] {
    padding-top: 24px;
  }

.click-through-mobile-contact-bar {
  background: #fff;
  height: 70px;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 9999999;
  display: flex;
  align-items: center;
  -webkit-box-shadow: -10px 0 20px -10px rgba(0, 0, 0, 0.1);
  box-shadow: -1px 0 15px -5px rgba(0, 0, 0, 0.16);
}

.click-through-mobile-contact-bar .mobile-dealer-logo {
  margin: 0 auto;
}

.click-through-mobile-contact-bar .mobile-dealer-logo img {
  padding: 10px;
}

.click-through-mobile-contact-bar .mobile-menu-toggle {
  margin-bottom: 6px;
  width: 60px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  float: left;
  background: transparent;
}

.click-through-mobile-contact-bar .mobile-menu-toggle .icon-bar {
  display: flex;
  width: 25px;
  height: 2px;
  border-radius: 1px;
  margin-top: 6px;
  width: 20px;
  padding: 1px;
  height: 1px;
  border-radius: 50px;
  background-color: #000;
}

.click-through-mobile-contact-bar .mobile-menu-toggle .icon-label {
  display: none;
}

.click-through-mobile-contact-bar .contact-info {
  float: right;
  margin-top: 0;
}

.click-through-mobile-contact-bar .contact-info #toggle-click-to-call {
  padding-top: 3px;
}

.click-through-mobile-contact-bar .contact-info .contact-item {
  display: inline-block;
  vertical-align: middle;
  color: #000;
  font-size: 2em;
  letter-spacing: .05em;
  margin-right: .5em;
}

.click-through-mobile-contact-bar .contact-info .contact-item:hover {
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
}

.click-through-mobile-contact-bar .contact-info .contact-item .fa {
  margin-right: .1em;
}

.click-through-mobile-contact-bar .contact-info .contact-item a {
  color: inherit;
}

.click-through-mobile-contact-bar .contact-info .contact-item a:hover {
  text-decoration: inherit;
}

.click-through-mobile-nav-bar {
  position: fixed;
  top: 0;
  z-index: 9999999;
  background: #000;
  font-family: inherit;
  height: 100vh;
  width: 100%;
  max-width: 660px;
  -webkit-transform: translateX(-110%);
  -ms-transform: translateX(-110%);
  transform: translateX(-110%);
  -webkit-box-shadow: -10px 0 20px -10px rgba(0, 0, 0, 0.1);
  box-shadow: -10px 0 20px -10px rgba(0, 0, 0, 0.1);
  -webkit-transition: .5s all ease-in-out;
  -o-transition: .5s all ease-in-out;
  transition: .5s all ease-in-out;
}

.click-through-mobile-nav-bar .mobile-dealer-logo {
  width: 80%;
}

.click-through-mobile-nav-bar .mobile-dealer-logo img {
  margin: auto;
  padding: 10px;
}

.click-through-mobile-nav-bar .dropdown-toggle:focus {
  outline: none;
}

.click-through-mobile-nav-bar .search-bar {
  background: transparent;
  clear: both;
}

.click-through-mobile-nav-bar .search-bar form {
  margin: 0;
}

.click-through-mobile-nav-bar .search-bar form .input-group {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
}

.click-through-mobile-nav-bar .search-bar form .input-group .input-search {
  margin: 0;
  padding: 10px;
  box-shadow: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.8);
}

.click-through-mobile-nav-bar .search-bar form .input-group .input-group-btn {
  padding: 0;
  width: auto;
  border-bottom: 1px solid rgba(255, 255, 255, 0.8);
}

.click-through-mobile-nav-bar .search-bar form .input-group .input-group-btn button {
  background: transparent;
  border: none;
  border-radius: 0;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  outline: none;
}

.click-through-mobile-nav-bar .navbar-outer {
  padding: 0 3.5rem;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 8vh;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-header-items {
  padding-bottom: 2.5rem;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner {
  display: block;
  overflow-y:auto;
  overflow-x: hidden;
  padding-bottom: 8vh;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner ul {
  padding-inline-start: 0px;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .side-nav {
  border: none;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .side-nav li a {
  background: transparent;
  display: block;
  font-size: 2rem;
  font-weight: 400;
  padding: 12px 0px;
  color: rgba(255, 255, 255, 0.8);
  text-align: left;
  text-decoration: none !important;
  margin: 0;
  box-shadow: none !important;
  line-height: normal;
  outline: none !important;
  white-space: normal;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .side-nav li ul.dropdown-menu {
  width: 100%;
  left: 0;
  display: none;
  position: relative;
  box-shadow: none;
  border-radius: inherit;
  border: none;
  background: transparent !important;
  margin: auto;
  padding: 0;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .side-nav .dropdown::after {
  content: "\f105";
  font-style: normal;
  text-rendering: auto;
  font-family: 'FontAwesome';
  padding: 9px 0px;
  font-size: 2rem;
  color: rgba(255, 255, 255, 0.8);
  position: absolute;
  right: 15px;
  top: 0;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .side-nav li.open-dropdown-view>a,
.click-through-mobile-nav-bar .navbar-outer .navbar-inner .side-nav li.dropdown.open-dropdown-view:after {
  display: none;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .side-nav li.open-dropdown-view ul.dropdown-menu {
  display: block;
  float: none;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .side-nav>li {
  padding: 0px 5px;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .close-dropdown-view {
  padding: 12px 5px;
  display: inline-block;
  text-decoration: none !important;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .close-dropdown-view:hover {
  cursor: pointer;
  color: rgba(255, 255, 255, 0.8);
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .close-dropdown-view img {
  height: 14px;
  opacity: .5;
  margin-right: 12px;
  position: relative;
  top: -2px;
}

.click-through-mobile-nav-bar .navbar-outer .navbar-inner .close-dropdown-view span {
  color: rgba(255, 255, 255, 0.5);
  font-size: 13px;
}

.click-through-mobile-nav-bar .navbar-directions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.click-through-mobile-nav-bar .navbar-directions .close-mobile-wrap {
  padding: 10px 5px;
  margin-left: auto;
  text-decoration: none !important;
}

.click-through-mobile-nav-bar .navbar-directions .close-mobile-wrap:hover {
  cursor: pointer;
}

.click-through-mobile-nav-bar .navbar-directions .close-mobile-wrap .close-mobile-nav {
  color: rgba(255, 255, 255, 0.8);
}

.click-through-mobile-nav-bar .navbar-directions .close-mobile-wrap .close-mobile-nav span {
  font-size: 32px;
  font-weight: normal;
  font-family: serif;
}

.click-through-mobile-nav-bar .navbar-directions .close-dropdown-view {
  padding: 12px 5px 6px;
  text-decoration: none !important;
}

.click-through-mobile-nav-bar .navbar-directions .close-dropdown-view:hover {
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
}

.click-through-mobile-nav-bar .navbar-directions .close-dropdown-view img {
  height: 18px;
  opacity: .8;
}

.click-through-mobile-nav-bar .fade-out {
  position: absolute;
  bottom: 8vh;
  left: 0;
  right: 0;
  z-index: 9999999;
  height: 8vh;
  background: -moz-linear-gradient(top, transparent 0%, black 99%, black 100%);
  background: -webkit-linear-gradient(top, transparent 0%, black 99%, black 100%);
  background: linear-gradient(to bottom, transparent 0%, black 99%, black 100%);
}

.offcanvas-menu .click-through-mobile-nav-bar {
  -webkit-transform: translateX(0%);
  -ms-transform: translateX(0%);
  transform: translateX(0%);
}

.click-through-mobile-contact-bar ul li ul li.active>a:hover {
  box-shadow: none;
}

@media (max-width: 767px) {
  .click-through-mobile-contact-bar {
    height: 55px;
  }

  .click-through-mobile-contact-bar .navbar-directions {
    height: 55px;
  }
}
</style>